var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6994_81259)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 90,
    r: 52,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 90,
    r: 51.5,
    stroke: "#1B9075"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6994_81259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.303 83.175L98.1862 71.562C96.5441 69.9371 94.3287 69.0235 92.0185 69.0186C89.7084 69.0137 87.489 69.9178 85.84 71.5357L73.695 83.175C72.8456 83.9931 72.1693 84.9736 71.7063 86.0583C71.2433 87.143 71.0032 88.3096 71 89.489V102.25C71.0028 104.57 71.9255 106.794 73.5659 108.434C75.2062 110.074 77.4302 110.997 79.75 111H104.25C106.57 110.997 108.794 110.074 110.434 108.434C112.074 106.794 112.997 104.57 113 102.25V89.489C112.997 88.3094 112.757 87.1426 112.293 86.0579C111.83 84.9732 111.153 83.9927 110.303 83.175ZM88.2882 74.0365C89.2806 73.0529 90.6227 72.5035 92.0198 72.5087C93.4169 72.514 94.7548 73.0735 95.7397 74.0645L107.547 85.3765L95.7118 97.2135C94.7113 98.1671 93.3822 98.6991 92 98.6991C90.6178 98.6991 89.2887 98.1671 88.2882 97.2135L76.4513 85.3765L88.2882 74.0365ZM109.5 102.25C109.5 103.642 108.947 104.978 107.962 105.962C106.978 106.947 105.642 107.5 104.25 107.5H79.75C78.3576 107.5 77.0223 106.947 76.0377 105.962C75.0531 104.978 74.5 103.642 74.5 102.25V89.489C74.5018 89.1493 74.5363 88.8105 74.6033 88.4775L85.8138 99.688C87.46 101.318 89.6832 102.233 92 102.233C94.3168 102.233 96.54 101.318 98.1862 99.688L109.397 88.4775C109.464 88.8105 109.498 89.1493 109.5 89.489V102.25Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6994_81259",
    x: 0,
    y: 0,
    width: 184,
    height: 184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6994_81259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6994_81259",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6994_81259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(71 69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0180016a601ee338add06f4733f8f87b.svg";
export { ForwardRef as ReactComponent };